import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from 'react';

import useTheme from '../../hooks/useTheme';
import { sanitizeMediaQuery } from './sanitizeMediaQuery';

const ResponsiveCtx = createContext({
  md: false,
  lg: false,
});

const isWindowObjDefined = typeof window !== 'undefined';

const ResponsiveProvider = ({
  children,
  matchMedia = isWindowObjDefined ? window.matchMedia : () => {},
}) => {
  const { mediaQueries } = useTheme();

  const [state, setState] = useState({
    0: false,
    1: false,
    length: 2,
  });

  useLayoutEffect(() => {
    const mediaMatchHandler = ({ matches, media }) => {
      const index = mediaQueries.findIndex(
        (query) => sanitizeMediaQuery(query) === sanitizeMediaQuery(media)
      );
      setState((current) => {
        return {
          ...current,
          [index]: matches,
        };
      });
    };

    if (matchMedia) {
      const mediaQueriesList = mediaQueries.map((mediaQueryString) => {
        const mediaQuery = matchMedia(mediaQueryString);
        mediaMatchHandler(mediaQuery);

        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', mediaMatchHandler);
        } else {
          mediaQuery.addListener(mediaMatchHandler);
        }

        return mediaQuery;
      });
      return () =>
        mediaQueriesList.map((mediaQuery) =>
          mediaQuery.removeEventListener
            ? mediaQuery.removeEventListener('change', mediaMatchHandler)
            : mediaQuery.removeListener(mediaMatchHandler)
        );
    }
  }, [mediaQueries, matchMedia]);

  return (
    <ResponsiveCtx.Provider
      value={{
        md: state[0], // width >= 768
        lg: state[1], // width >= 1200
      }}
    >
      {children}
    </ResponsiveCtx.Provider>
  );
};

export const useMediaQueries = () => useContext(ResponsiveCtx);
export default ResponsiveProvider;
